import React, {FC, useState} from "react"

import authentication from "@irati/auth"
import styled from "styled-components"
import History, {appOrContext, useAppRouteContext} from "@irati/utils/history"
import {WALLET} from "@irati-tracking/tracker/products"
import {walletTracking} from "@irati-tracking/wallet"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {H4} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"

import {useIsLoggedIn} from "@irati/auth/helpers/auth/useAuth"
import Loading from "@irati/ui/src/Loading"
import {useHeaderWallet} from "../../utils/wallet"
import DesktopMenu from "../DesktopMenu"
import OldRewardWallet from "./RewardWallet"
import AdminRewardWallet from "./AdminRewardWallet"
import UserWalletWithPoints from "./UserWalletWithPoints"
import {MenuWrapper} from "./styled"
import UserWallet from "./UserWallet"

export const StyledMenu = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: ${({theme}) => theme.colors.utility.highlight};
  border-radius: ${({theme}) => theme.border.radius.medium};
  cursor: pointer;
  margin-left: ${({theme}) => theme.spacing.one};
  padding: 4px 10px;
  height: 40px;
`

const StyledCurrencyContainer = styled.div`
  font-weight: bold;
  color: ${({theme}) => theme.colors.greys.black};
`

export const Separator = styled.div`
  border-left: 1px solid lightgray;
  margin: 0 10px;
  height: 25px;
`

const WalletMenu: FC = () => {
  const {app} = useAppRouteContext()
  const [isMenuDisplayed, setIsMenuDisplayed] = useState(false)
  const {load, data} = useHeaderWallet()
  const isLoggedIn = useIsLoggedIn()
  const hasManagerWallet = authentication.apps("wallet.flexiRewards.canRewardEmployees") || authentication.apps("wallet.rewardWallet")
  const idNamespace = "header-wallet"

  if (!isLoggedIn) {
    return null
  }

  const toggle = () => {
    setIsMenuDisplayed((current) => !current)
  }

  const handleClick = () => {
    if (!hasManagerWallet) {
      walletTracking.clickWalletBalance(app, data?.balance, data?.currency, "header")
      History.push(appOrContext({to: "/", app: WALLET}, ""))
    } else {
      toggle()
    }
  }

  if (!authentication.apps("perks") && data?.currency === "TT") return null

  return (
    <Loading useLoader={false} load={load}>
      {data?.currency && (
        <DesktopMenu
          id="platform_header_wallet_button"
          show={isMenuDisplayed}
          toollgtip="wallet"
          onClick={handleClick}
          onOutsideClick={toggle}
          content={
            hasManagerWallet && (
              <MenuWrapper>
                <H4 marginTop={2} marginBottom={2} padding={[0, 2]}>
                  <FormattedMessage id="platform.wallet.menu.wrapper.title" />
                </H4>
                {authentication.apps("wallet.rewardWallet") ? (
                  <UserWallet
                    id={idNamespace}
                    text="platform.wallet.menu.user.title"
                    onClick={() => walletTracking.clickWalletBalance(app, 0, "", "walletDropdown")}
                  />
                ) : (
                  <UserWalletWithPoints
                    id={idNamespace}
                    onClick={() => walletTracking.clickWalletBalance(app, data.balance, data.currency, "walletDropdown")}
                  />
                )}
                <AdminRewardWallet id={idNamespace} toggle={toggle} />

                <OldRewardWallet id={idNamespace} />
              </MenuWrapper>
            )
          }>
          <StyledMenu>
            <Icon icon={IconTypes.wallet} size={20} />
            <Separator />
            <StyledCurrencyContainer>
              <FormattedCurrency fontSize={18} value={data.balance} currency={data.currency} />
            </StyledCurrencyContainer>
          </StyledMenu>
        </DesktopMenu>
      )}
    </Loading>
  )
}

export default WalletMenu
